<template>
    <div class="main">
        <div class="cbanner">
            <img src="../../../assets/images/banner_contact.jpg" />
            <div class="btext">
                <h3>借贷知识</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">

            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>政策法规</el-breadcrumb-item>
                <el-breadcrumb-item>借贷知识</el-breadcrumb-item>
            </el-breadcrumb>

            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="2"
                            class="el-menu-vertical-demo">
                        <router-link :to="{path:'/policiesRegulations'}">
                            <el-menu-item index="1"><span slot="title">政策法规</span></el-menu-item>
                        </router-link>
                        <router-link :to="{path:'borrowingKnowledge'}">
                            <el-menu-item index="2"><span slot="title">借贷知识</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="news_detail">
                            <h1 class="title_news" v-if="showDetail">{{this.BorrowingKnowledgeDetail.title}}</h1>
                            <div class="date_news" v-if="showDetail">发布日期：{{this.BorrowingKnowledgeDetail.publishTime|date_from_unix_YearMonthDay}} &nbsp;&nbsp;&nbsp;&nbsp;发布人：{{this.BorrowingKnowledgeDetail.publisher}}</div>
                            <div class="content_news" v-html="this.BorrowingKnowledgeDetail.content"></div>

                            <div class="news_more" v-if="showDetail">
                                <a class="prev" v-on:click="getPrevious(BorrowingKnowledgeDetail.rownum)" v-bind:class="{temporary: BorrowingKnowledgeDetail.rownum==1}"><b>上一篇：</b>{{this.BorrowingKnowledgeDetail.rownum==1?'没有上一篇':perviousTitle}}</a>
                                <a class="next" v-on:click="getNext(BorrowingKnowledgeDetail.rownum)" v-bind:class="{temporary: BorrowingKnowledgeDetail.rownum==this.lastOne}"><b>下一篇：</b>{{this.BorrowingKnowledgeDetail.rownum==this.lastOne?'没有下一篇':nextTitle}}</a>
                                <div class="clear"></div>
                            </div>

                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqBorrowingKnowledgeDetailById,reqBorrowingKnowledgeDetailPervious,reqBorrowingKnowledgeDetailNext} from "../../../api/contentManagement-api";
    export default {
        data(){
            return{
                BorrowingKnowledgeDetail:[],
                showDetail:true,
                perviousTitle:'',
                nextTitle:'',
                lastOne:'',
            }
        },
        methods:{
            getBorrowingKnowledgeDetail(id){
                reqBorrowingKnowledgeDetailById({id:id}).then((res)=>{
                    if(res.data.code===1){
                        this.BorrowingKnowledgeDetail=res.data.data;
                        this.getPerviousTitle(this.BorrowingKnowledgeDetail.rownum);
                        this.getNextTitle(this.BorrowingKnowledgeDetail.rownum);
                    }else{
                        this.BorrowingKnowledgeDetail='<p>抱歉，暂无数据</p>';
                        this.showDetail=false;
                    }
                })
            },

            getPerviousTitle:function (rownum) {
                reqBorrowingKnowledgeDetailPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                    }
                })
            },
            getNextTitle:function (rownum) {
                reqBorrowingKnowledgeDetailNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.nextTitle=res.data.data.title;
                    }
                })
            },

//   上下篇内容
            getPrevious:function (rownum) {
                reqBorrowingKnowledgeDetailPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.BorrowingKnowledgeDetail=res.data.data;
                        this.getPerviousTitle(this.BorrowingKnowledgeDetail.rownum);
                        this.getNextTitle(this.BorrowingKnowledgeDetail.rownum);
                    }
                })
            },
            getNext:function (rownum) {
                reqBorrowingKnowledgeDetailNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.BorrowingKnowledgeDetail=res.data.data;
                        this.getPerviousTitle(this.BorrowingKnowledgeDetail.rownum);
                        this.getNextTitle(this.BorrowingKnowledgeDetail.rownum);
                    }
                })
            },

        },
        mounted(){
           var total=this.$route.query.total;
           this.lastOne=total;
            var id=this.$route.query.id;
            this.getBorrowingKnowledgeDetail(id);
        },
    }

</script>
<style>

    .news_more {
        line-height: 1.6em; padding:24px 0; margin-top:24px;
    }
    .prev {
        float: left;
    }
    .next {
        float: right; text-align: right;
    }
    .temporary {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>


// WEBPACK FOOTER //
// src/components/contentManagement/policiesRegulations/BorrowingKnowledgeDetail.vue